/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const StyledSpan = styled.span`
    font-size: 12px;
    color: #707070;
    font-weight: 600;
    line-height: 14.63px;
`;
